import type { Template } from "@/types";

export const LA_06_H3_V3: Template[] = [
    {
        id: "la-06-h3v3-01",
        name: "LA 01 - H3V3",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.80/la-06-h3_v3_01.png",
        size: [1352, 483],
        style: {},
        slots: [
            { id: "1", x: 112, y: 59, width: 187, height: 116, rotation: 0, imageRotation: 0 },
            { id: "2", x: 112, y: 183, width: 187, height: 116, rotation: 0, imageRotation: 0 },
            { id: "3", x: 112, y: 307, width: 187, height: 116, rotation: 0, imageRotation: 0 },
            { id: "4", x: 306, y: 59, width: 260, height: 364, rotation: 0, imageRotation: 0 },
            { id: "5", x: 750, y: 59, width: 260, height: 364, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1018, y: 59, width: 260, height: 364, rotation: 0, imageRotation: 0 }  
        ],
    },

    {
        id: "la-06-h3v3-02",
        name: "LA 02 - H3V3",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.80/la-06-h3_v3_02.png",
        size: [1352, 483],
        style: {},
        slots: [
            { id: "1", x: 120, y: 42, width: 281, height: 399, rotation: 0, imageRotation: 0 },
            { id: "2", x: 408, y: 42, width: 143, height: 196, rotation: 0, imageRotation: 0 },
            { id: "3", x: 408, y: 245, width: 143, height: 196, rotation: 0, imageRotation: 0 },
            { id: "4", x: 805, y: 42, width: 420, height: 255, rotation: 0, imageRotation: 0 },
            { id: "5", x: 805, y: 304, width: 206, height: 136, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1019, y: 304, width: 206, height: 136, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-06-h3v3-03",
        name: "LA 03 - H3V3",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.80/la-06-h3_v3_03.png",
        size: [1352, 483],
        style: {},
        slots: [
            { id: "1", x: 127, y: 42, width: 420, height: 255, rotation: 0, imageRotation: 0 },
            { id: "2", x: 127, y: 304, width: 206, height: 136, rotation: 0, imageRotation: 0 },
            { id: "3", x: 341, y: 304, width: 206, height: 136, rotation: 0, imageRotation: 0 },
            { id: "4", x: 800, y: 42, width: 281, height: 399, rotation: 0, imageRotation: 0 },           
            { id: "5", x: 1089, y: 42, width: 143, height: 196, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1089, y: 246, width: 143, height: 195, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-06-h3v3-04",
        name: "LA 04 - H3V3",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.80/la-06-h3_v3_04.png",
        size: [1352, 483],
        style: {},
        slots: [      
            { id: "1", x: 123, y: 42, width: 320, height: 196, rotation: 0, imageRotation: 0 },
            { id: "2", x: 123, y: 246, width: 320, height: 196, rotation: 0, imageRotation: 0 },
            { id: "3", x: 450, y: 42, width: 103, height: 128, rotation: 0, imageRotation: 0 },
            { id: "4", x: 450, y: 178, width: 103, height: 128, rotation: 0, imageRotation: 0 },
            { id: "5", x: 450, y: 314, width: 103, height: 128, rotation: 0, imageRotation: 0 },
            { id: "6", x: 752, y: 75, width: 523, height: 332, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-06-h3v3-05",
        name: "LA 05 - H3V3",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.80/la-06-h3_v3_05.png",
        size: [1352, 483],
        style: {},
        slots: [
            { id: "1", x: 109, y: 41, width: 225, height: 285, rotation: 0, imageRotation: 0 },
            { id: "2", x: 342, y: 41, width: 225, height: 285, rotation: 0, imageRotation: 0 },
            { id: "3", x: 109, y: 333, width: 148, height: 108, rotation: 0, imageRotation: 0 },
            { id: "4", x: 265, y: 333, width: 148, height: 108, rotation: 0, imageRotation: 0 },
            { id: "5", x: 420, y: 333, width: 147, height: 108, rotation: 0, imageRotation: 0 },
            { id: "6", x: 876, y: 41, width: 276, height: 400, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-06-h3v3-06",
        name: "LA 06 - H3V3",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.80/la-06-h3_v3_06.png",
        size: [1352, 483],
        style: {},
        slots: [
            { id: "1", x: 0, y: 88, width: 446, height: 308, rotation: 0, imageRotation: 0 },
            { id: "2", x: 453, y: 88, width: 219, height: 308, rotation: 0, imageRotation: 0 },
            { id: "3", x: 680, y: 88, width: 220, height: 151, rotation: 0, imageRotation: 0 },
            { id: "4", x: 680, y: 246, width: 220, height: 150, rotation: 0, imageRotation: 0 },
            { id: "5", x: 907, y: 88, width: 219, height: 308, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1133, y: 88, width: 219, height: 308, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-06-h3v3-07",
        name: "LA 07 - H3V3",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.80/la-06-h3_v3_07.png",
        size: [1352, 483],
        style: {},
        slots: [
            { id: "1", x: 0, y: 88, width: 446, height: 308, rotation: 0, imageRotation: 0 },
            { id: "2", x: 680, y: 88, width: 220, height: 308, rotation: 0, imageRotation: 0 },
            { id: "3", x: 453, y: 88, width: 219, height: 151, rotation: 0, imageRotation: 0 },
            { id: "4", x: 453, y: 246, width: 219, height: 150, rotation: 0, imageRotation: 0 },
            { id: "5", x: 907, y: 88, width: 219, height: 308, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1133, y: 88, width: 219, height: 308, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-06-h3v3-08",
        name: "LA 08 - H3V3",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.80/la-06-h3_v3_08.png",
        size: [1352, 483],
        style: {},
        slots: [
            { id: "1", x: 0, y: 88, width: 446, height: 308, rotation: 0, imageRotation: 0 },
            { id: "2", x: 453, y: 88, width: 219, height: 308, rotation: 0, imageRotation: 0 },
            { id: "3", x: 680, y: 88, width: 220, height: 308, rotation: 0, imageRotation: 0 },
            { id: "4", x: 907, y: 88, width: 219, height: 308, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1133, y: 88, width: 219, height: 151, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1133, y: 246, width: 219, height: 150, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-06-h3v3-09",
        name: "LA 09 - H3V3",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.80/la-06-h3_v3_09.png",
        size: [1352, 483],
        style: {},
        slots: [
            { id: "1", x: 53, y: 61, width: 142, height: 178, rotation: 0, imageRotation: 0 },
            { id: "2", x: 203, y: 61, width: 292, height: 178, rotation: 0, imageRotation: 0 },
            { id: "3", x: 53, y: 246, width: 292, height: 177, rotation: 0, imageRotation: 0 },
            { id: "4", x: 353, y: 246, width: 142, height: 177, rotation: 0, imageRotation: 0 },
            { id: "5", x: 503, y: 61, width: 530, height: 362, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1040, y: 61, width: 260, height: 362, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-06-h3v3-10",
        name: "LA 10 - H3V3",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.80/la-06-h3_v3_10.png",
        size: [1352, 483],
        style: {},
        slots: [
            { id: "1", x: 53, y: 61, width: 142, height: 178, rotation: 0, imageRotation: 0 },
            { id: "2", x: 203, y: 61, width: 292, height: 178, rotation: 0, imageRotation: 0 },
            { id: "3", x: 53, y: 246, width: 292, height: 177, rotation: 0, imageRotation: 0 },
            { id: "4", x: 353, y: 246, width: 142, height: 177, rotation: 0, imageRotation: 0 },
            { id: "5", x: 503, y: 61, width: 260, height: 362, rotation: 0, imageRotation: 0 },
            { id: "6", x: 770, y: 61, width: 530, height: 362, rotation: 0, imageRotation: 0 }
        ],
    }
];